import { ORDER } from '../core/systems.js';
/**
 * Character physics: crowd separation, knockback integration, gravity/ground
 * clamping, launch arcs, ragdoll-lite tumbling. Publishes w.physics.
 */
export function createPhysics() {
  return {
    name: 'physics', order: ORDER.PHYSICS,
    init(w) { w.physics = { separation: true, push(id, fx, fz) { w.entities.vx[id] += fx; w.entities.vz[id] += fz; } }; },
    fixedUpdate(w, dt) {},
  };
}
